import { render, staticRenderFns } from "./create-audit-task.vue?vue&type=template&id=9bb513de&scoped=true"
import script from "./create-audit-task.vue?vue&type=script&lang=js"
export * from "./create-audit-task.vue?vue&type=script&lang=js"
import style0 from "./create-audit-task.vue?vue&type=style&index=0&id=9bb513de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb513de",
  null
  
)

export default component.exports